<template>
    <div class="category-tree" v-loading="loading">
        <el-checkbox v-model="classifyExpand" @change="handleCheckedTreeExpand($event, 'classify')">展开/折叠</el-checkbox>
        <el-checkbox v-model="classifyNodeAll" @change="handleCheckedTreeNodeAll($event, 'classify')">全选/全不选</el-checkbox>
        <!-- <el-checkbox v-model="classifyCheckStrictly" @change="handleCheckedTreeConnect($event, 'classify')">父子联动</el-checkbox> -->
        <el-tree
            :data="dataTree"
            :props="defaultProps"
            node-key="id"
            :default-expanded-keys="expandedKeys"
            :expand-on-click-node="false"
            show-checkbox
            ref="classifyTree"
            :default-checked-keys="defaultCheckedKeys"
            :check-strictly="classifyCheckStrictly"
            @check="handleCheckChange"
            @node-click="handleNodeClick"
            empty-text="加载中，请稍后"
        >
            <span class="custom-tree-node" slot-scope="{ node, data }">
                <span class="node-label">
                    <span class="node-name">{{ data.name }} {{ data.id }}</span>
                    <span v-if="data.image" class="node-image">
                        <el-avatar size="small" :src="data.image" alt=""></el-avatar>
                    </span>
                </span>
            </span>
        </el-tree>
    </div>
</template>

<script>
export default {
    name: 'CategoryTree',
    props: {
        dataTree: {
            type: Array,
            default: () => []
        },
        checkedKeys: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            // 树形组件属性配置
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            // 默认展开的节点
            expandedKeys: [],
            // 默认选中的节点
            defaultCheckedKeys: [],
            classifyExpand: false,
            classifyNodeAll: false,
            classifyCheckStrictly: true,
            loading: false
        };
    },
    computed: {
        // 将分类数据转换为树形结构
        categoryTree() {
            // console.log('-------computed-----categoryTree---------------------');
            // console.log(this.data.length);
            // 如果外部传入了数据，则使用外部数据，否则使用默认数据
            return this.data && this.data.length > 0 ? this.data : [this.getDefaultData()];
        }
    },
    watch: {
        dataTree: {
            handler(newVal) {
                this.$nextTick(() => {
                    // 当数据更新时，根据节点的checked属性设置勾选状态
                    this.setCheckedKeysByData(newVal);
                });
            },
            immediate: true
        },
        checkedKeys: {
            handler(newVal) {
                this.defaultCheckedKeys = newVal;
            },
            immediate: true
        }
    },
    mounted() {
        // 在组件挂载后根据数据设置默认选中项
        this.$nextTick(() => {
            this.setCheckedKeysByData(this.dataTree);
        });
    },
    methods: {
        // 获取默认数据
        getDefaultData() {
            return {
                id: 7,
                image: '',
                banner: '',
                pid: 0,
                name: '载入中',
                level: 1,
                state: 2,
                r: 0,
                checked: true,
                children: [
                    {
                        id: 8,
                        image: '',
                        banner: '',
                        pid: 7,
                        name: '载入中',
                        level: 2,
                        state: 2,
                        r: 0,
                        checked: false,
                        children: [
                            {
                                id: 40,
                                image: 'https://hengqikeji.oss-cn-shanghai.aliyuncs.com/2025-07-02/abb13a3a-83ce-423e-b93c-0215fa87b198/e5d08e4a9279e594.png',
                                banner: '',
                                pid: 8,
                                name: '载入中',
                                level: 3,
                                state: 2,
                                r: 0,
                                checked: true,
                                children: null
                            }
                        ]
                    }
                ]
            };
        },
        // 处理节点点击事件
        handleNodeClick(data) {
            console.log('点击节点:', data);
            this.$emit('node-click', data);
        },

        getAllRelatedIds(selectedIds) {
            const idSet = new Set();

            selectedIds.forEach((id) => {
                // 添加当前节点
                idSet.add(id);

                // 添加祖先节点
                const parentIds = this.findParentIds(id);
                parentIds.forEach((pid) => idSet.add(pid));

                // 添加后代节点
                // const childIds = this.findChildrenIds(id);
                // childIds.forEach((cid) => idSet.add(cid));
            });

            return Array.from(idSet);
        },

        // 查找祖先节点ID
        findParentIds(targetId) {
            // 使用之前递归DFS的方法
            const path = [];
            const traverse = (nodes, currentPath) => {
                for (const node of nodes) {
                    const newPath = [...currentPath, node.id];
                    if (node.id === targetId) {
                        path.push(...currentPath); // 只添加祖先（不包括自身）
                        return true;
                    }
                    if (node.children) {
                        if (traverse(node.children, newPath)) {
                            return true;
                        }
                    }
                }
                return false;
            };

            traverse(this.dataTree, []);
            return path;
        },

        // 查找所有子级ID（递归）
        findChildrenIds(parentId) {
            const childrenIds = [];

            const findNode = (nodes) => {
                for (const node of nodes) {
                    if (node.id === parentId) {
                        // 找到目标节点，收集所有后代ID
                        collectChildren(node);
                        return true;
                    }

                    if (node.children) {
                        const found = findNode(node.children);
                        if (found) return true;
                    }
                }
                return false;
            };

            const collectChildren = (node) => {
                if (!node.children) return;
                for (const child of node.children) {
                    // 设置父节点ID（用于判断直接子节点）
                    child.parentId = node.id;
                    childrenIds.push(child.id);
                    collectChildren(child);
                }
            };

            findNode(this.dataTree);
            return childrenIds;
        },

        // 获取所有子级ID（直接子级+后代）
        childrenIds(selectedIds) {
            const result = [];
            selectedIds.forEach((id) => {
                const children = this.findChildrenIds(id);
                result.push(...children);
            });
            return [...new Set(result)]; // 去重
        },
        // 获取所有父级ID（直接父级+祖先）
        parentIds(selectedIds) {
            const result = [];
            selectedIds.forEach((id) => {
                const parents = this.findParentIds(id);
                result.push(...parents);
            });
            return [...new Set(result)]; // 去重
        },

        // 处理节点勾选变化
        handleCheckChange(data, checkedInfo) {
            // console.log('勾选节点:', data);
            console.log('勾选信息:', checkedInfo);

            const checkedIds = this.getAllRelatedIds(checkedInfo.checkedKeys);
            console.log(checkedIds, ';checkedIds');
            // 获取所有选中节点的ID
            // const checkedKeys = checkedInfo.checkedKeys;

            // 向父组件传递勾选变化事件
            this.$emit('checkChange', {
                checked: checkedInfo.checkedNodes,
                checkedKeys: checkedIds,
                halfChecked: checkedInfo.halfCheckedNodes,
                halfCheckedKeys: checkedInfo.halfCheckedKeys,
                node: data,
                checkedInfo: checkedInfo
            });
        },
        // 获取当前选中的节点
        getCheckedNodes() {
            return this.$refs.classifyTree ? this.$refs.classifyTree.getCheckedNodes() : [];
        },
        // 获取当前选中节点的key
        getCheckedKeys() {
            return this.$refs.classifyTree ? this.$refs.classifyTree.getCheckedKeys() : [];
        },
        // 设置选中节点
        setCheckedKeys(keys) {
            this.$nextTick(() => {
                if (this.$refs.classifyTree) {
                    this.$refs.classifyTree.setCheckedKeys(keys);
                }
            });
        },
        // 树权限（展开/折叠）
        handleCheckedTreeExpand(value, type) {
            if (type === 'classify') {
                let treeList = this.dataTree;
                for (let i = 0; i < treeList.length; i++) {
                    this.$refs.classifyTree.store.nodesMap[treeList[i].id].expanded = value;
                }
            }
        },
        // 树权限（全选/全不选）
        handleCheckedTreeNodeAll(value, type) {
            if (type === 'classify') {
                // 获取所有叶子节点
                const allLeafKeys = this.getAllLeafKeys(this.dataTree);
                const keysToCheck = value ? allLeafKeys : [];
                this.$refs.classifyTree.setCheckedKeys(keysToCheck);

                // 更新checkedIds - 触发check事件来更新选中状态
                this.$nextTick(() => {
                    // 获取当前选中信息
                    const checkedNodes = this.$refs.classifyTree.getCheckedNodes();
                    const checkedKeys = this.$refs.classifyTree.getCheckedKeys();
                    const halfCheckedNodes = this.$refs.classifyTree.getHalfCheckedNodes();
                    const halfCheckedKeys = this.$refs.classifyTree.getHalfCheckedKeys();

                    // 向父组件传递更新后的选中信息
                    this.$emit('checkChange', {
                        checked: checkedNodes,
                        checkedKeys: this.getAllRelatedIds(checkedKeys),
                        halfChecked: halfCheckedNodes,
                        halfCheckedKeys: halfCheckedKeys,
                        node: null,
                        checkedInfo: {
                            checkedNodes,
                            checkedKeys,
                            halfCheckedNodes,
                            halfCheckedKeys
                        }
                    });
                });
            }
        },
        // 树权限（父子联动）
        handleCheckedTreeConnect(value, type) {
            if (type === 'classify') {
                this.classifyCheckStrictly = value ? false : true;
            }
        },
        // 获取所有叶子节点的key
        getAllLeafKeys(nodes) {
            let keys = [];
            if (!nodes) return keys;

            nodes.forEach((node) => {
                if (!node.children || node.children.length === 0) {
                    // 叶子节点
                    keys.push(node.id);
                } else {
                    // 递归处理子节点
                    keys = keys.concat(this.getAllLeafKeys(node.children));
                }
            });
            return keys;
        },
        // 根据数据中的checked属性设置勾选状态
        setCheckedKeysByData(nodes) {
            this.loading = true;
            if (!nodes || !this.$refs.classifyTree) return;
            this.classifyCheckStrictly = true;
            const checkedKeys = this.extractCheckedKeys(nodes);
            this.defaultCheckedKeys = checkedKeys;

            this.$nextTick(() => {
                if (this.$refs.classifyTree) {
                    this.$refs.classifyTree.setCheckedKeys(checkedKeys);
                    this.loading = false;
                    setTimeout(() => {
                        this.classifyCheckStrictly = false;
                    }, 100);
                }
            });
        },
        // 从数据中提取所有checked为true的节点key
        extractCheckedKeys(nodes) {
            const result = [];
            if (!nodes || !nodes.length) return result;

            // 使用栈实现迭代DFS（深度优先搜索）
            const stack = [...nodes];

            while (stack.length) {
                const node = stack.pop();

                // 添加选中节点
                if (node.checked) {
                    result.push(node.id);
                }

                // 添加子节点到栈中
                if (node.children && node.children.length) {
                    // 使用展开运算符避免反向遍历
                    stack.push(...[...node.children].reverse());
                }
            }

            return result;
        }
    }
};
</script>

<style scoped>
.category-tree {
    padding: 20px;
}

.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
}

.node-label {
    display: flex;
    align-items: center;
    gap: 8px;
}

.node-name {
    font-weight: 500;
}

.node-level {
    font-size: 12px;
    color: #999;
}

.node-image {
    color: #409eff;
}
</style>
